module.exports = "<h1 class=\"text-danger\">error 404</h1>"